function Suggestion ({ children }) {
    return (
        <li>{children}</li>
    );
}

export default Suggestion;